module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-dune-timber-hamilton-0.ce53fe4c.jpg";